import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { getAccDetailsByAccountId, getPlatformFees, getPymtConfDetails, getPymtDetailsByPymtNo, getTransactionDetails } from '../actions/payments';
import { cancelPayment } from '../actions/payments';
import { acceptPayment } from '../actions/payments';
import { rejectPayment } from '../actions/payments';
import { getMultiCountryAllowance } from '../actions/payments';
export interface BLPaymentDetails {
  blId: string;
}

interface BLPaymentDetailsList {
  list: BLPaymentDetails[];
  next: string | null;
  previous: string | null;
}

export interface BlPaymentSlice {
  paymentMode: any;
  bankOptions: any;
  pymtModeOptions: any;
  dataLoading: boolean;
  data: BLPaymentDetailsList;
  pymtNo: string;
  pymtMode: any;
  bnkNm: string;
  accNo: string;
  pymtAmt: any;
  localamount:any;
  amountDetails: any;
  editPayment: boolean;
  pymtCurr: any;
  localccy:any;
  platformFee: any;
  totalInvAmt: any;
  pymtConf:any;
  payorAccountId: any;
  paymentRefNumber: any;
  radioValue: string;
  pmtStatus: string;
  linerRemarks?: any;
  pmtId: any;
  paymentSubmitLoader: any;
  fileName: string;
  paymentTransactionDetails:any;
  cancelPaymentLoader: any;
  acceptPaymentLoader: any;
  rejectPaymentLoader: any;
  platformChargeConfigId: string;
  multiCurrencyAllow: any;
  enkapPollingActive: boolean;
  enkapOrderId: string | null;
  enkapPollingStartTime: number | null;
}

const initialState: BlPaymentSlice = {
  paymentMode: 1,
  amountDetails: '',
  editPayment: false,
  linerRemarks: '',
  bankOptions: [],
  paymentTransactionDetails:[],
  pymtModeOptions: [],
  data: {
    list: [],
    next: null,
    previous: null,
  },
  dataLoading: true,
  pymtNo: '',
  pymtMode: 1,
  bnkNm: '',
  accNo: '',
  pymtAmt: '',
  pymtCurr: '',
  localamount:'',
  localccy:'',
  platformFee: '',
  pymtConf:{},
  totalInvAmt: '',
  payorAccountId: null,
  paymentRefNumber: '',
  radioValue: '',
  pmtStatus: '',
  pmtId: null,
  paymentSubmitLoader: false,
  fileName: '',
  cancelPaymentLoader: false,
  acceptPaymentLoader: false,
  rejectPaymentLoader: false,
  platformChargeConfigId: '',
  multiCurrencyAllow: false,
  enkapPollingActive: false,
  enkapOrderId: null,
  enkapPollingStartTime: null
};

export const blPaymentSlice = createSlice({
  name: 'blPayment',
  initialState,
  reducers: {
    updatePaymentMode: (state, action: PayloadAction<string>) => {
      state.paymentMode = action.payload;
    },
    updateAmountMode: (state, action: PayloadAction<string>) => {
      state.amountDetails = action.payload;
    },
    setEditPayment: (state, action: PayloadAction<boolean>) => {
      state.editPayment = action.payload;
    },
    updateBanks: (state, action: PayloadAction<any>) => {
      state.bankOptions = action.payload;
    },
    updatePymtModeOptions: (state, action: PayloadAction<any>) => {
      state.pymtModeOptions = action.payload;
    },
    paymentLoader: (state, action: PayloadAction<any>) => {
      state.paymentSubmitLoader = action.payload;
    },
    updatePymtData: (state, action: PayloadAction<any>) => {
      state.pymtMode = action.payload.pmtMode;
      state.pymtNo =
        action.payload.odexRefNo != ''
          ? action.payload.odexRefNo
          : action.payload.bankRefNo;
      state.bnkNm = action.payload.payorBankName;
      state.accNo = action.payload.payorAccountNo;
      state.pymtAmt = action.payload.paymentAmount;
      state.pymtCurr = action.payload.currency;
      state.payorAccountId = action.payload.payorAccountId;
      state.radioValue = action.payload.refType == 1 ? 'auto' : 'generate';
      state.pmtStatus = action.payload.pmtStatus;
      state.pmtId = action.payload.pmtId;
      state.fileName = action.payload.fileName;
      state.linerRemarks = action.payload.linerRemarks;
      state.platformFee = action.payload.totalPlatformCharges;
      state.totalInvAmt = action.payload.totalInvAmt;
      state.localamount = action.payload.localAmount;
      state.localccy = action.payload.localCcy;
      
    },
    clearPaymentId:(state)=>{
      state.pmtId = null;
    },
    resetFileName: (state) => {
      state.fileName = '';
    },
    setPaymentStatus: (state, action: PayloadAction<string>) => {
      state.pmtStatus = action.payload;
    },
    updatePymtRefNumber: (state, action: PayloadAction<any>) => {
      state.paymentRefNumber = action.payload;
    },
    resetPaymentLoaders: (state) => {
      state.acceptPaymentLoader = false;
      state.rejectPaymentLoader = false;
      state.cancelPaymentLoader = false;
      state.paymentSubmitLoader = false;
    },
    setEnkapPolling: (state, action: PayloadAction<{active: boolean, orderId?: string}>) => {
      state.enkapPollingActive = action.payload.active;
      state.enkapOrderId = action.payload.orderId || null;
      state.enkapPollingStartTime = action.payload.active ? Date.now() : null;
    },
    resetEnkapPolling: (state) => {
      state.enkapPollingActive = false;
      state.enkapOrderId = null;
      state.enkapPollingStartTime = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPymtDetailsByPymtNo.pending, (state, action) => {
      state.dataLoading = true;
    });
    builder.addCase(getPymtDetailsByPymtNo.fulfilled, (state, action) => {
      state.dataLoading = false;
      //state.data = action.payload;
    });

    builder.addCase(getPymtConfDetails.fulfilled, (state, action) => {
      
      state.pymtConf = action.payload;
    });
    
    builder.addCase(cancelPayment.pending, (state, action) => {
      state.cancelPaymentLoader = true;
    });
    builder.addCase(cancelPayment.fulfilled, (state, action) => {
      setTimeout(() => {
        state.cancelPaymentLoader = false;
      }, 2000);
    });
    builder.addCase(cancelPayment.rejected, (state, action) => {
      state.cancelPaymentLoader = false;
    });

    builder.addCase(acceptPayment.pending, (state, action) => {
      state.acceptPaymentLoader = true;
    });

    builder.addCase(acceptPayment.fulfilled, (state, action) => {
      setTimeout(() => {
        state.acceptPaymentLoader = false;
      }, 2000);
    });

    builder.addCase(acceptPayment.rejected, (state, action) => {
      state.acceptPaymentLoader = false;
    });

    builder.addCase(rejectPayment.pending, (state, action) => {
      state.rejectPaymentLoader = true;
    });

    builder.addCase(getTransactionDetails.fulfilled, (state, action) => {
      state.paymentTransactionDetails = action.payload;
    });

    builder.addCase(getTransactionDetails.rejected, (state) => {
      state.paymentTransactionDetails = [];
    });

    builder.addCase(rejectPayment.fulfilled, (state, action) => {
      setTimeout(() => {
        state.rejectPaymentLoader = false;
      }, 2000);
    });

    builder.addCase(rejectPayment.rejected, (state, action) => {
      state.rejectPaymentLoader = false;
    });

    builder.addCase(getPlatformFees.fulfilled, (state, action)=>{
      state.platformChargeConfigId = action.payload.platformChargeConfigId
      state.platformFee = action.payload.platformFee
    })

    builder.addCase(getAccDetailsByAccountId.pending,(state)=>{
      state.bnkNm = ''
      state.accNo= ''
    })

    builder.addCase(getAccDetailsByAccountId.fulfilled, (state, action)=>{
      state.bnkNm = action.payload.bankName
      state.accNo = action.payload.accNo
    })

    builder.addCase(getMultiCountryAllowance.fulfilled, (state, action)=>{
      state.multiCurrencyAllow = action.payload
    })
  },
});

export const {
  updatePaymentMode,
  updateBanks,
  updatePymtModeOptions,
  updatePymtData,
  updateAmountMode,
  updatePymtRefNumber,
  paymentLoader,
  setEditPayment,
  setPaymentStatus,
  resetPaymentLoaders,
  clearPaymentId,
  resetFileName,
  setEnkapPolling,
  resetEnkapPolling
} = blPaymentSlice.actions;

export default blPaymentSlice.reducer;
